import type { BlockDef } from './types.js';
import { cardBlock, columnsBlock, dividerBlock, gridBlock, spacerBlock, stackBlock } from './blocks/layout.js';
import {
  eyebrowBlock,
  headingBlock,
  paragraphBlock,
  richtextBlock,
  sectionHeaderBlock,
} from './blocks/text.js';
import { iconBlock, imageBlock, logoBlock } from './blocks/media.js';
import {
  checklistBlock,
  dataTableBlock,
  faqListBlock,
  glanceBandBlock,
  statBarBlock,
  stepsListBlock,
  tocListBlock,
} from './blocks/data.js';
import { calloutBlock, coverDecorBlock, ctaBandBlock, pageFooterBlock } from './blocks/brand.js';

/** Palette order: layout, text, media, data, brand. */
export const BLOCK_DEFS: readonly BlockDef[] = [
  stackBlock,
  columnsBlock,
  gridBlock,
  cardBlock,
  spacerBlock,
  dividerBlock,
  sectionHeaderBlock,
  eyebrowBlock,
  headingBlock,
  paragraphBlock,
  richtextBlock,
  imageBlock,
  iconBlock,
  logoBlock,
  dataTableBlock,
  statBarBlock,
  tocListBlock,
  glanceBandBlock,
  faqListBlock,
  stepsListBlock,
  checklistBlock,
  ctaBandBlock,
  calloutBlock,
  pageFooterBlock,
  coverDecorBlock,
];

export const BLOCKS_BY_TYPE: ReadonlyMap<string, BlockDef> = new Map(
  BLOCK_DEFS.map((def) => [def.type, def]),
);
